<nz-card [nzTitle]="null" class="picture-card-box" *ngIf="files.length">
    <div nz-card-grid *ngFor="let file of files; index as i" [ngStyle]="gridStyle">
        <app-file-preview [src]="file?.path" [fileName]="file?.originalname" 
        (fileDelete)="deleteFile(i)" [deleteEnabled]="deleteEnabled"></app-file-preview>
    </div>
  </nz-card>